// Action types
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const RESET = 'RESET';
export const BRANCH_OFFICE = 'BRANCH_OFFICE';
export const COST_CENTER = 'COST_CENTER';
export const VIEW_INSTANCE = 'VIEW_INSTANCE';
export const DATA_TRAVEL = 'DATA_TRAVEL';

export function increaseCount() {
  return { type: INCREMENT };
}

export function decreaseCount() {
  return { type: DECREMENT };
}

export function resetCount() {
  return { type: RESET };
}

export function dataTravel(payload) {
  return { type: DATA_TRAVEL, payload };
}

function readPermissions() {
  const raw = localStorage.getItem('permissions');
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    localStorage.removeItem('permissions');
    return [];
  }
}

export function validatePermission(permission) {
  const permissions = readPermissions();

  if (permission && typeof permission === 'object' && !Array.isArray(permission)) {
    const required = permission.all;
    return (
      Object.keys(permission).length === 1 &&
      Object.prototype.hasOwnProperty.call(permission, 'all') &&
      Array.isArray(required) &&
      required.length > 0 &&
      Array.from(required).every(
        (slug) =>
          typeof slug === 'string' &&
          slug.length > 0 &&
          permissions.some((item) => item?.slug === slug && item?.active),
      )
    );
  }

  if (Array.isArray(permission)) {
    if (permission.length === 0) return false;
    const hasPermission = permission.find((slug) =>
      permissions.some((item) => item?.slug === slug && item?.active),
    );
    return !!hasPermission;
  }

  if (typeof permission === 'string' && permission) {
    return !!permissions.find((item) => item?.slug === permission && item?.active);
  }

  return false;
}

export function currentBranchOffice(costCenter = {}) {
  return {
    type: BRANCH_OFFICE,
    value: costCenter.branch_office_id,
    name: costCenter.branch_office_name,
  };
}

export function currentCostCenter(costCenter = {}) {
  return {
    type: COST_CENTER,
    value: costCenter.id,
    name: costCenter.name,
  };
}
